import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { ssoExchange } from '../../../api/ssoApi';

/** Landing after the identity provider (SRS #74–#76): swaps the one-time code in the URL fragment for the session. */
export const SsoCompletePage: React.FC = () => {
  const navigate = useNavigate();
  const { loginWithResponse } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('code');
    if (!code) { setError('Missing sign-in code.'); return; }
    window.history.replaceState(null, '', window.location.pathname);   // the code must not linger in history
    ssoExchange(code).then((data) => {
      loginWithResponse(data);
      navigate(data.new_user ? '/onboarding' : data.return_to || '/dashboard', { replace: true });
    }).catch((e) => setError(e instanceof Error ? e.message : 'Sign-in failed'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: 'inherit' }}>
      {error ? (
        <div style={{ textAlign: 'center' }}>
          <p style={{ color: 'var(--ds-danger-text)' }}>{error}</p>
          <a href="/login">Back to sign in</a>
        </div>
      ) : <p>Completing sign-in…</p>}
    </div>
  );
};

export default SsoCompletePage;
